import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { Tooltip } from "@material-ui/core";

import BWGridAPI from "../../../../ui/BWGrid/BWGridAPI";
import GridHeader from "../../../../ui/BWGrid/GridHeader";
import GridTable from "../../../../ui/BWGrid/GridTable";
import SpecShipment from "../../../../../models/SpecShipment";
import Counter from "../../../../ui/Counter";
import { BWIntent } from "../../../../ui/BWIntent";
import CardRight from "../CardRight";
import {
  PlaceholderCounter,
  ShipmentColumn,
  ShipmentsTotalSpan,
} from "./components";
import {
  FutureDeliveryWarningIcon,
  shouldDisplayFutureWarning,
} from "../../../ProjectDetail/Shipments/SpecShipments/components";
import { Error } from "../../../../inputs/LabeledPONumber";

const WarningIconWrapper = styled.span`
  display: inline-block;
  vertical-align: middle;
`;

const NoShipmentsWarningIcon = () => {
  return (
    <WarningIconWrapper>
      <Tooltip
        title="Shipment line item exists but no shipments have been created"
        placement="right-start"
      >
        <Error
          color={BWIntent.values.backgroundColors.warning}
          badgeSize={20}
        />
      </Tooltip>
    </WarningIconWrapper>
  );
};

const intents = BWIntent.values.counters;

const CounterOrPlaceholder = ({ value, intent }) =>
  value ? <Counter value={value} intent={intent} /> : <PlaceholderCounter />;

CounterOrPlaceholder.propTypes = {
  value: PropTypes.number,
  intent: PropTypes.string,
};

export const Shipments = row => {
  const {
    shipmentsCount = 0,
    shipmentsNeedsFollowUp,
    successShipments,
    shipments = [],
  } = row;

  const futureDeliveryWarning = shipments.some(shipment =>
    shouldDisplayFutureWarning(shipment, "actualDeliveryDate")
  );

  const hasNoShipments = shipmentsCount === 0;

  return (
    <ShipmentColumn>
      {futureDeliveryWarning && (
        <FutureDeliveryWarningIcon fieldName="actualDeliveryDate" />
      )}
      {hasNoShipments && <NoShipmentsWarningIcon />}
      <CounterOrPlaceholder value={successShipments} intent={intents.success} />
      <CounterOrPlaceholder value={shipmentsNeedsFollowUp} />
      <ShipmentsTotalSpan>Total {shipmentsCount}</ShipmentsTotalSpan>
    </ShipmentColumn>
  );
};

Shipments.propTypes = {
  shipmentsCount: PropTypes.number,
  shipmentsNeedsFollowUp: PropTypes.number,
  successShipments: PropTypes.number,
};

const columns = ["id", "shipmentsCount"];
const columnsOptions = {
  id: { title: "Spec ID", width: "66px" },
  shipmentsCount: { fill: true, align: "left", render: Shipments },
};

const Table = ({ dataComponent, rootFilters, gridHeaderText }) => {
  return (
    <CardRight>
      <BWGridAPI
        apiRoute="spec-shipments"
        dataComponent={dataComponent}
        model={SpecShipment}
        rootFilters={rootFilters}
      >
        <GridHeader subheaderText={gridHeaderText} />
        <GridTable columns={columns} columnOptions={columnsOptions} />
      </BWGridAPI>
    </CardRight>
  );
};

Table.propTypes = {
  dataComponent: PropTypes.object.isRequired,
  rootFilters: PropTypes.object.isRequired,
  gridHeaderText: PropTypes.string.isRequired,
};

export default Table;
